import r, { useRef as a, useEffect as c } from "react";
const s = ({ html: t }) => {
  const e = a(null);
  return c(() => {
    if (!t || !e.current)
      return;
    const n = document.createRange().createContextualFragment(t);
    e.current.append(n);
  }, []), /* @__PURE__ */ r.createElement("div", {
    style: { display: "contents" },
    ref: e
  });
};
export {
  s as default
};
